import { createSelector } from 'reselect';
import classesVarSelector from './classesVar';

export default createSelector(classesVarSelector, (classesVars) => classesVars?.minBookingDates);
